import React, { useState } from "react";
import Header from './Header';
import Footer from './Footer';
import Note from './Note';
import CreateNote from "./CreateNote";

function App(){

  const [notes, setNotes] = useState([]);

  function addNote(note) {

      setNotes(previousNotes => {
          return ([...previousNotes, note]);
        });
  }

  function deleteNote(id) {
    setNotes(previousNotes => {
      return previousNotes.filter( (noteDetail, index) => {
      return index !== id;
     });
   });
  }

  return ( 
  <div>
    <Header />
    <CreateNote whenAdd={addNote}/>
    
    {notes.map( (noteDetail , index) =>  
    <Note 
      key= {index}
      id= {index}
      title={noteDetail.title} 
      content={noteDetail.content}
      whenDelete={deleteNote}
      />
)}

    <Footer />
  </div>);
}

export default App;
